export default __webpack_public_path__ + "static/media/bitcoin_blog_cropped.0e99fbe7.jpg";